const StarlightWaltzLead = {
    name: "Starlight Waltz",
    bpm: 174,
    signature: "6/8",
    introMeasures: 8,
    pattern: [

    ]
};

export default StarlightWaltzLead;